import { useEffect, useState } from "react";
import { MdDeleteOutline, MdModeEditOutline } from "react-icons/md";
import { TbFileSearch } from "react-icons/tb";
import { Grid, Table } from "semantic-ui-react";
import { useDeleteFacility } from "../../../api/facility";
import { CommonTable, TitleView } from "../../../components";
import ConfirmModal from "../../../components/confirmViewModal/ConfirmModal";
import PaginationView from "../../../components/pagination/Pagination";
import { facilitySimulationTableCol } from "../../../config/tableColConstant";
import { successMessage } from "../../../helpers/ErrorHandler";
import FacilitySimulationEditModal from "./FacilitySimulationEditModal";
import FacilitySimulationViewModal from "./FacilitySimulationViewModal";

const FacilitySimulationTable = ({
  data,
  setPageNumber,
  setPageSize,
  pageNumber,
  pageSize,
  refetch
}: any) => {
  const [totalFacilitySimulation, setTotalFacilitySimulation] = useState(0);
  const [editFacilityData, setEditFacilityData] = useState<any>({});
  const [viewFacilityData, setViewFacilityData] = useState<any>({});
  const [deleteFacilityData, setDeleteFacilityData] = useState<any>({});
  const [showDeleteFacilityModal, setShowDeleteFacilityModal] = useState(false);
  const [visibleFacilitySimulationEditModal, setVisibleFacilitySimulationEditModal] =
    useState(false);
  const [visibleFacilitySimulationViewModal, setVisibleFacilitySimulationViewModal] =
    useState(false);
  const { mutate: deleteFacility } = useDeleteFacility();

  useEffect(() => {
    if (data) {
      setPageNumber(data.page || 1);
      setPageSize(data.pageSize || 5);
      setTotalFacilitySimulation(data.total || 0);
    }
  }, [data]);

  const handleFacilityView = (detailsToView: any) => {
    setViewFacilityData(detailsToView);
    setVisibleFacilitySimulationViewModal(true);
  };

  const handleFacilityEdit = (detailsToEdit: any) => {
    setEditFacilityData(detailsToEdit);
    setVisibleFacilitySimulationEditModal(true);
  };

  const handleChangeView = () => {
    setVisibleFacilitySimulationViewModal(false);
    setEditFacilityData(viewFacilityData);
    setVisibleFacilitySimulationEditModal(true);
  };

  const handleFacilityDelete = (detailsToDelete: any) => {
    setDeleteFacilityData(detailsToDelete);
    setShowDeleteFacilityModal(true);
  };

  //delete facility data
  const deleteFacilityDetails = (data: any) => {
    deleteFacility(data, {
      onSuccess: () => {
        refetch();
      }
    });
  };

  const loadHistoryTableData = () => {
    if (data.result.length === 0) {
      return (
        <Table.Row>
          <Table.Cell colSpan="2" textAlign="center">
            No simulations available
          </Table.Cell>
        </Table.Row>
      );
    }

    return data.result.map((item: any, index: number) => (
      <Table.Row className="tbleR" key={item._id || index}>
        <Table.Cell>{item.facilityName || "N/A"}</Table.Cell>
        <Table.Cell>
          <Grid>
            <Grid.Column computer={5} tablet={16} mobile={16}>
              <TbFileSearch
                cursor="pointer"
                onClick={() => {
                  handleFacilityView(item);
                }}
                size={24}
                color="var(--tableEditIcon)"
              />
            </Grid.Column>
            <Grid.Column computer={5} tablet={16} mobile={16}>
              <MdModeEditOutline
                cursor="pointer"
                onClick={() => {
                  handleFacilityEdit(item);
                }}
                size={24}
                color="var(--tableEditIcon)"
              />
            </Grid.Column>
            <Grid.Column computer={5} tablet={16} mobile={16}>
              <MdDeleteOutline
                onClick={() => {
                  handleFacilityDelete({
                    _id: item?._id
                  });
                }}
                cursor="pointer"
                size={24}
                color="var(--tableEditIcon)"
              />
            </Grid.Column>
          </Grid>
        </Table.Cell>
      </Table.Row>
    ));
  };

  return (
    <>
      <TitleView title="Facility Simulations" CustomTitleViewMain="facilityRegisterTitle" />
      <CommonTable tableHeaderData={facilitySimulationTableCol}>
        {loadHistoryTableData()}
      </CommonTable>
      <div style={{ margin: "10px 0" }}>
        <PaginationView
          currentPageNo={pageNumber}
          totalPages={Math.ceil(totalFacilitySimulation / pageSize)}
          pageSize={pageSize}
          currentSelectPage={(page: number) => {
            setPageNumber(page);
          }}
          changePageSize={(pageSize: number) => {
            setPageNumber(1);
            setPageSize(pageSize);
          }}
        />
      </div>
      {visibleFacilitySimulationViewModal && (
        <FacilitySimulationViewModal
          visibleModal={visibleFacilitySimulationViewModal}
          setVisibleModal={setVisibleFacilitySimulationViewModal}
          facilityId={viewFacilityData?._id}
          handleChangeView={handleChangeView}
        />
      )}
      {visibleFacilitySimulationEditModal && (
        <FacilitySimulationEditModal
          visibleModal={visibleFacilitySimulationEditModal}
          setVisibleModal={setVisibleFacilitySimulationEditModal}
          facilityId={editFacilityData?._id}
          refetch={refetch}
        />
      )}
      <ConfirmModal
        viewModal={showDeleteFacilityModal}
        closeModal={() => setShowDeleteFacilityModal(false)}
        cancel={() => {
          setShowDeleteFacilityModal(false);
          setDeleteFacilityData({});
        }}
        approve={() => {
          deleteFacilityDetails(deleteFacilityData);
          successMessage("Facility removed successfully");
          setDeleteFacilityData({});
          setShowDeleteFacilityModal(false);
        }}
        title="Delete Facility Data"
        subTitle="Are you sure you want to delete the facility?"
      />
    </>
  );
};

export default FacilitySimulationTable;
